import { Injectable } from "@angular/core";
import { Firebase } from "@ionic-native/firebase";
import { Platform } from "ionic-angular";
import { AngularFirestore } from "angularfire2/firestore";
import { FirebaseApp } from "angularfire2";
import { AngularFireAuth } from "angularfire2/auth";

@Injectable()
export class FcmProvider {
  constructor(
    public firebaseNative: Firebase,
    public afs: AngularFirestore,
    private platform: Platform,
    public afireauth: AngularFireAuth,
  ) {}

  // Get permission from the user
  async getToken() {
    let token=null;

    if (this.platform.is("android")) {
      token = await this.firebaseNative.getToken();
    }

    if (this.platform.is("ios")) {
      token = await this.firebaseNative.getToken();
      await this.firebaseNative.grantPermission();
    }

    if(token!=null)
      return this.saveTokenToFirestore(token);
  }

  // Save the token to firestore
  private saveTokenToFirestore(token) {
    if (!token) return;
  
    const devicesRef = this.afs.collection(`devices`)
  
    const docData = { 
      token,
      userId: this.afireauth.auth.currentUser.uid,
    }
  
    return devicesRef.doc(token).set(docData)
  }

  // Listen to incoming FCM messages
  listenToNotifications() {
    return this.firebaseNative.onNotificationOpen()
  }
}



// WEBPACK FOOTER //
// ./src/providers/fcm/fcm.ts